const { RichTextToolbarButton } = wp.blockEditor;
const { __ } = wp.i18n;

/**
 * AddGreenTagStyle
 *
 * A React component that renders a button for removing link style from a rich text editor.
 *
 * @param {object} params - The parameters for the component.
 * @param {boolean} params.isActive - Determines whether the button is active or not.
 * @param {string} params.value - The current value of the rich text editor.
 * @param {function} params.onChange - A callback function to handle the change in the rich text editor value.
 *
 * @return {ReactElement} - The React element representing the AddGreenTagStyle component.
 */
const AddGreenTagStyle = ( { isActive, value, onChange } ) => {

	return (
		<RichTextToolbarButton
			icon="button"
			title={ __( 'Green tag', 'wombat' ) }
			onClick={ () => {

				onChange(
					wp.richText.toggleFormat( value, {
						type: 'wombat/green-tag-style',
					} )
				);

			} }
			isActive={ isActive }
		/>
	);

};

wp.richText.registerFormatType( 'wombat/green-tag-style', {
	title: __( 'Green tag style', 'wombat' ),
	tagName: 'span',
	className: 'is-style-green-tag',
	edit: AddGreenTagStyle,
} );
